"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GAEventNameVal = exports.GtmInitBrandVal = exports.GDPRNewGroupStatusVal = exports.GDPRNewGroupsVal = exports.GDPRGroupStateVal = exports.GDPRGroupsVal = exports.GtmLoginTypeVal = exports.GtmLoginStatusVal = exports.GtmRegistrationTypeVal = exports.GtmPageTypeVal = exports.GtmInitPlatformVal = exports.GtmDepositTypeVal = exports.GtmLoginMethodVal = exports.GtmLobbyNameVal = exports.GtmFilterEnabledVal = exports.GtmDataLayerVarVal = exports.GtmEventActionVal = void 0;
exports.GtmEventActionVal = {
    AccountVerificationClick: "AccountVerificationClick",
    AccountVerificationConfirmed: "AccountVerificationConfirmed",
    AccountVerificationOpen: "AccountVerificationOpen",
    AppDownloadBannerClicked: "AppDownloadBannerClicked",
    AppDownloadBannerClosed: "AppDownloadBannerClosed",
    AppDownloadBannerShown: "AppDownloadBannerShown",
    BackgroundToggle: "BackgroundToggle",
    BankIDOpen: "BankIDOpen",
    BankIDStart: "BankIDStart",
    BankIDVerification: "BankIDVerification",
    BannerClick: "BannerClick",
    BetConfirmed: "BetConfirmed",
    BetFailed: "BetFailed",
    BetslipDetail: "BetslipDetail",
    BonusBackBannerClick: "BonusBackBannerClick",
    BonusClaimFailed: "BonusClaimFailed",
    BonusClaimSuccess: "BonusClaimSuccess",
    BonusClick: "BonusClick",
    BonusDetailsClick: "BonusDetailsClick",
    BonusDetailsOpen: "BonusDetailsOpen",
    BonusOptInFailed: "BonusOptInFailed",
    BonusOptInSuccess: "BonusOptInSuccess",
    BonusSelection: "BonusSelection",
    BonusSelectionClick: "BonusSelectionClick",
    BonusSelectionOpen: "BonusSelectionOpen",
    BottomNavigationClick: "BottomNavigationClick",
    BrandHeaderLogo: "BrandHeaderLogo",
    BurgerMenuClick: "BurgerMenuClick",
    CarouselCardClick: "CarouselCardClick",
    CarouselNavigationClick: "CarouselNavigationClick",
    CasinoFilterAdded: "CasinoFilterAdded",
    CasinoFilterRemoved: "CasinoFilterRemoved",
    CasinoWidgetClick: "CasinoWidgetClick",
    CasinoWidgetTabClick: "CasinoWidgetTabClick",
    ChangePasswordFailed: "ChangePasswordFailed",
    ChangePasswordFormOpen: "ChangePasswordFormOpen",
    ChangePasswordFormSubmit: "ChangePasswordFormSubmit",
    ChangePasswordSuccess: "ChangePasswordSuccess",
    ChangeRegistrationType: "ChangeRegistrationType",
    CloseNavigationPopup: "CloseNavigationPopup",
    ClosePopup: "ClosePopup",
    ConfirmedDeposit: "ConfirmedDeposit",
    ConfirmedRegistration: "ConfirmedRegistration",
    ConsentChange: "ConsentChange",
    ConsentConfirmed: "ConsentConfirmed",
    ConsentOpen: "ConsentOpen",
    ConsentSubmitted: "ConsentSubmitted",
    CreateAccount: "CreateAccount",
    CreateAccountClick: "CreateAccountClick",
    CreateCouponSubmit: "CreateCouponSubmit",
    DebugBearError: "DebugBearError",
    DebugBearLoaded: "DebugBearLoaded",
    DepositLimitCalculate: "DepositLimitCalculate",
    DepositLimitCalculatorFieldChange: "DepositLimitCalculatorFieldChange",
    DepositLimitCalculatorLinkClick: "DepositLimitCalculatorLinkClick",
    DepositWithoutBonus: "DepositWithoutBonus",
    ElementClicked: "ElementClicked",
    ElementSeen: "ElementSeen",
    EngagementClick: "EngagementClick",
    EskimiLoaded: "EskimiLoaded",
    ExitIntentModalClick: "ExitIntentModalClick",
    ExitIntentModalDismissed: "ExitIntentModalDismissed",
    ExitIntentModalShow: "ExitIntentModalShow",
    FailedRegistration: "FailedRegistration",
    FavouriteGameClick: "FavouriteGameClick",
    FirstDeposit: "FirstDeposit",
    ForgottenPassword: "ForgottenPassword",
    ForgottenPasswordFailed: "ForgottenPasswordFailed",
    ForgottenPasswordSuccess: "ForgottenPasswordSuccess",
    FundsProtectionOpen: "FundsProtectionOpen",
    GameBottomNavigationClick: "GameBottomNavigationClick",
    GameCategoryHeaderClick: "GameCategoryHeaderClick",
    GameFrameClick: "GameFrameClick",
    GamePlayedForFun: "GamePlayedForFun",
    GamePlayedForReal: "GamePlayedForReal",
    GDPRConsent: "GDPRConsent",
    GenericButtonClick: "GenericButtonClick",
    GenericFormFailed: "GenericFormFailed",
    GenericFormFieldChange: "GenericFormFieldChange",
    GenericFormOpen: "GenericFormOpen",
    GenericFormSubmit: "GenericFormSubmit",
    GenericFormSuccess: "GenericFormSuccess",
    GtagUpdate: "GtagUpdate",
    HomeCategoryClick: "HomeCategoryClick",
    HomeItemClick: "HomeItemClick",
    HomeVisits: "HomeVisits",
    InsertBonusCode: "InsertBonusCode",
    LinkClick: "LinkClick",
    LiveEventVisit: "LiveEventVisit",
    LiveStreamInteraction: "LiveStreamInteraction",
    LoginFailed: "LoginFailed",
    LoginFailure: "LoginFailure",
    LoginFieldChange: "LoginFieldChange",
    LoginFieldChangeTop: "LoginFieldChangeTop",
    LoginFormOpen: "LoginFormOpen",
    LoginIntention: "LoginIntention",
    LoginPasswordFormSubmit: "LoginPasswordFormSubmit",
    LoginSubmitted: "LoginSubmitted",
    LoginSubmittedTop: "LoginSubmittedTop",
    LoginTabClick: "LoginTabClick",
    LoginUsernameFormSubmit: "LoginUsernameFormSubmit",
    MainNavigationClick: "MainNavigationClick",
    MarketSelectorApplied: "MarketSelectorApplied",
    MarketSelectorClick: "MarketSelectorClick",
    MitIDClose: "MitIDClose",
    MitIDOpen: "MitIDOpen",
    MultiMarketToggle: "MultiMarketToggle",
    MultipleGameWindow: "MultipleGameWindow",
    MyAccountClick: "MyAccountClick",
    MyGamesClick: "MyGamesClick",
    MyGamesViewAllClick: "MyGamesViewAllClick",
    NemIDClose: "NemIDClose",
    NemIDOpen: "NemIDOpen",
    NotSwedishRegClick: "NotSwedishRegClick",
    OMSClick: "OMSClick",
    OpenAccountWidget: "OpenAccountWidget",
    OpenDepPage: "OpenDepPage",
    OpenMobileBankID: "OpenMobileBankID",
    OpenPopupClick: "OpenPopupClick",
    OpenRegPage: "OpenRegPage",
    OverlayMessage: "OverlayMessage",
    PaymentAmountChange: "PaymentAmountChange",
    PaymentFailed: "PaymentFailed",
    PaymentFieldChange: "PaymentFieldChange",
    PaymentProviderPopUp: "PaymentProviderPopUp",
    PaymentProviderWindowOpen: "PaymentProviderWindowOpen",
    PaymentsConnectionTiming: "PaymentsConnectionTiming",
    PaymentScreenClose: "PaymentScreenClose",
    PaymentSelectionChange: "PaymentSelectionChange",
    PaymentSelectionSubmit: "PaymentSelectionSubmit",
    PaymentsInitPolling: "PaymentsInitPolling",
    PaymentsPlatformError: "PaymentsPlatformError",
    PaymentValidationFailed: "PaymentValidationFailed",
    PinClick: "PinClick",
    PlaceBetClick: "PlaceBetClick",
    PokerClick: "PokerClick",
    PokerPromotionsClick: "PokerPromotionsClick",
    PokerSideGames: "PokerSideGames",
    PokerSideGamesNavigation: "PokerSideGamesNavigation",
    ProductFavouriteClick: "ProductFavouriteClick",
    ProductFilterApplied: "ProductFilterApplied",
    ProductFilterClick: "ProductFilterClick",
    ProductNavigationClick: "ProductNavigationClick",
    ProductSortApplied: "ProductSortApplied",
    ProductSortClick: "ProductSortClick",
    PromotionBannerClick: "PromotionBannerClick",
    ProviderPopupBlocked: "ProviderPopupBlocked",
    QuickLinksScroller: "QuickLinksScroller",
    RegIntention: "RegIntention",
    RegistrationActivity: "RegistrationActivity",
    RegistrationClicks: "RegistrationClicks",
    RegistrationFailedNextStepClick: "RegistrationFailedNextStepClick",
    RegistrationFieldChange: "RegistrationFieldChange",
    RegistrationFieldChange2: "RegistrationFieldChange2",
    RegistrationFieldError: "RegistrationFieldError",
    RegistrationLoginClick: "RegistrationLoginClick",
    RegistrationPostStepClick: "RegistrationPostStepClick",
    RegistrationSubmitted: "RegistrationSubmitted",
    ResetPasswordFailed: "ResetPasswordFailed",
    ResetPasswordFormOpen: "ResetPasswordFormOpen",
    ResetPasswordFormSubmit: "ResetPasswordFormSubmit",
    ResetPasswordSuccess: "ResetPasswordSuccess",
    SearchCasino: "SearchCasino",
    SearchClick: "SearchClick",
    SearchGameCategoryClick: "SearchGameCategoryClick",
    SearchLinkClick: "SearchLinkClick",
    SearchSelected: "SearchSelected",
    SetNewPassword: "SetNewPassword",
    SettingsClick: "SettingsClick",
    SGAHeaderLogo: "SGAHeaderLogo",
    SkipPassword: "SkipPassword",
    SmartBannerClick: "SmartBannerClick",
    SmartIDFormClick: "SmartIDFormClick",
    SmartIDLoginVerificationOpen: "SmartIDLoginVerificationOpen",
    SmartIDRegVerificationErrorClick: "SmartIDRegVerificationErrorClick",
    SmartIDRegVerificationFailed: "SmartIDRegVerificationFailed",
    SmartIDRegVerificationOpen: "SmartIDRegVerificationOpen",
    SmartIDRegVerificationSuccess: "SmartIDRegVerificationSuccess",
    SportsbookBannerClick: "SportsbookBannerClick",
    SportsBookNavigationClick: "SportsBookNavigationClick",
    SportsbookPreferenceChange: "SportsbookPreferenceChange",
    SportsbookSearchClick: "SportsbookSearchClick",
    SportsbookSubCategoryClick: "SportsbookSubCategoryClick",
    SportsbookWidgetClick: "SportsbookWidgetClick",
    SuccessfulGameAdded: "SuccessfulGameAdded",
    SuccessfulLogin: "SuccessfulLogin",
    TabbedComponentInteraction: "TabbedComponentInteraction",
    TikTokLoaded: "TikTokLoaded",
    TiledFilterClick: "TiledFilterClick",
    TopBurgerMenuClick: "TopBurgerMenuClick",
    TopNavigationClick: "TopNavigationClick",
    TournamentsClick: "TournamentsClick",
    TournamentsFailed: "TournamentsFailed",
    TournamentsGamesNavigation: "TournamentsGamesNavigation",
    TournamentsNavigation: "TournamentsNavigation",
    TournamentsOpen: "TournamentsOpen",
    TournamentsOptInFailed: "TournamentsOptInFailed",
    TournamentsOptInSuccess: "TournamentsOptInSuccess",
    TournamentsTabNavigation: "TournamentsTabNavigation",
    TrustlyClose: "TrustlyClose",
    TrustlyOpen: "TrustlyOpen",
    TwoFADisableConfirmationCancel: "TwoFADisableConfirmationCancel",
    TwoFADisableConfirmationOpen: "TwoFADisableConfirmationOpen",
    TwoFADisableConfirmationTurnoff: "TwoFADisableConfirmationTurnoff",
    TwoFALoginPasswordCancel: "TwoFALoginPasswordCancel",
    TwoFALoginPasswordFailed: "TwoFALoginPasswordFailed",
    TwoFALoginPasswordSubmit: "TwoFALoginPasswordSubmit",
    TwoFALoginPasswordSuccess: "TwoFALoginPasswordSuccess",
    TwoFAMobileSMSAuthCancel: "TwoFAMobileSMSAuthCancel",
    TwoFAMobileSMSAuthChange: "TwoFAMobileSMSAuthChange",
    TwoFAMobileSMSAuthContinue: "TwoFAMobileSMSAuthContinue",
    TwoFAMobileSMSAuthOpen: "TwoFAMobileSMSAuthOpen",
    TwoFANotificationClick: "TwoFANotificationClick",
    TwoFANotificationOpen: "TwoFANotificationOpen",
    TwoFASetupClick: "TwoFASetupClick",
    TwoFASetupDisabled: "TwoFASetupDisabled",
    TwoFASetupOpen: "TwoFASetupOpen",
    TwoFASetupSuccess: "TwoFASetupSuccess",
    TwoFASetupTurnOffClick: "TwoFASetupTurnOffClick",
    TwoFASMSVerificationCode: "TwoFASMSVerificationCode",
    VerificationBarShown: "VerificationBarShown",
    VerificationStartClick: "VerificationStartClick",
    VerifiedRegistration: "VerifiedRegistration",
    VerifyAccountClick: "VerifyAccountClick",
    VerifyAccountOpen: "VerifyAccountOpen",
    ViewAllHeaderClick: "ViewAllHeaderClick",
    ViewOtherPaymentMethods: "ViewOtherPaymentMethods",
    VirtualPageView: "VirtualPageView",
    WebsiteToggle: "WebsiteToggle",
    WelcomeMessageClick: "WelcomeMessageClick",
    WelcomeMessageOpen: "WelcomeMessageOpen",
    WidgetHomeClick: "WidgetHomeClick",
    Withdrawal: "Withdrawal"
};
exports.GtmDataLayerVarVal = {
    Action: "Action",
    ActiveGameFrames: "ActiveGameFrames",
    ActivityName: "ActivityName",
    Age: "Age",
    Amount: "Amount",
    Area: "Area",
    BackgroundState: "BackgroundState",
    BalanceAmount: "BalanceAmount",
    BannerName: "BannerName",
    BannerPosition: "BannerPosition",
    BetType: "BetType",
    Bonus_ID: "Bonus_ID",
    BonusTitle: "BonusTitle",
    BonusType: "BonusType",
    CampaignClicked: "CampaignClicked",
    CardClicked: "CardClicked",
    CategoryClicked: "CategoryClicked",
    CategoryID: "CategoryID",
    CategoryName: "CategoryName",
    CD_ClickType: "CD_ClickType",
    CD_GRE_Selection: "CD_GRE_Selection",
    CD_Position: "CD_Position",
    ChildOrigin: "ChildOrigin",
    ClickArea: "ClickArea",
    ClickUrl: "ClickUrl",
    CompetitionID: "CompetitionID",
    CompetitionName: "CompetitionName",
    ComponentID: "ComponentID",
    ComponentName: "ComponentName",
    ComponentType: "ComponentType",
    ConnectionStatus: "ConnectionStatus",
    ConnectionTiming: "ConnectionTiming",
    ConsentFields: "ConsentFields",
    Country: "Country",
    CouponID: "CouponID",
    cs_lobby_faq_category: "cs_lobby_faq_category",
    cs_lobby_faq_id: "cs_lobby_faq_id",
    Currency: "Currency",
    custom_timerEventNumber: "custom.timerEventNumber",
    DebugEvent: "DebugEvent",
    DepositLimitAmount: "DepositLimitAmount",
    DepositType: "DepositType",
    Destination: "Destination",
    Direction: "Direction",
    ecommerce_items: "ecommerce.items",
    ElementClicked: "ElementClicked",
    ElementID: "ElementID",
    ElementName: "ElementName",
    EndDate: "EndDate",
    Error: "Error",
    EventID: "EventID",
    EventName: "EventName",
    FavArea: "FavArea",
    FieldCount: "FieldCount",
    FieldName: "FieldName",
    FilterEnabled: "FilterEnabled",
    FilterItem: "FilterItem",
    FilterItemBucket: "FilterItemBucket",
    FiltersApplied: "FiltersApplied",
    FormName: "FormName",
    GAEventName: "GAEventName",
    Game_Intent: "Game_Intent",
    GameCategory: "GameCategory",
    GameCollectionPosition: "GameCollectionPosition",
    GameID: "GameID",
    GameName: "GameName",
    GameProvider: "GameProvider",
    gdpr_functional_enabled: "gdpr_functional_enabled",
    gdpr_performance_enabled: "gdpr_performance_enabled",
    gdpr_targeting_enabled: "gdpr_targeting_enabled",
    GDPRFunctionalAccepted: "GDPRFunctionalAccepted",
    GDPRPerformanceAccepted: "GDPRPerformanceAccepted",
    GDPRTargetingAccepted: "GDPRTargetingAccepted",
    gtm_init_brand: "gtm_init_brand",
    gtm_init_environment: "gtm_init_environment",
    gtm_init_platform: "gtm_init_platform",
    gtm_init_traffic: "gtm_init_traffic",
    gtm_is_cookie_consent_disabled: "gtm_is_cookie_consent_disabled",
    gtm_static: "gtm_static",
    GUID: "GUID",
    HashedEmail: "HashedEmail",
    IDProof: "IDProof",
    ItemClicked: "ItemClicked",
    Jurisdiction: "Jurisdiction",
    KYCStatus: "KYCStatus",
    Label: "Label",
    Language: "Language",
    LiveStreamAction: "LiveStreamAction",
    Lobby: "Lobby",
    LobbyName: "LobbyName",
    Location: "Location",
    LoginMethod: "LoginMethod",
    LoginStatus: "LoginStatus",
    LoginType: "LoginType",
    MarketTemplateID: "MarketTemplateID",
    Method: "Method",
    Native_App_Name: "Native_App_Name",
    Native_App_Version: "Native_App_Version",
    OMStitle: "OMStitle",
    pageId: "pageId",
    PageType: "PageType",
    PageView_Bucket: "PageView_Bucket",
    PartnerID: "PartnerID",
    PaymentFlowType: "PaymentFlowType",
    PlatformName: "PlatformName",
    Product_Theme: "Product_Theme",
    ProductName: "ProductName",
    PromotionName: "PromotionName",
    PromotionType: "PromotionType",
    Provider: "Provider",
    providers: "providers",
    PublicPaymentId: "PublicPaymentId",
    RegistrationCountry: "RegistrationCountry",
    RegistrationMethod: "RegistrationMethod",
    RegistrationProduct: "RegistrationProduct",
    RegistrationStep: "RegistrationStep",
    RegistrationType: "RegistrationType",
    ReleaseName: "ReleaseName",
    ReleaseVersion: "ReleaseVersion",
    RememberStakeFlag: "RememberStakeFlag",
    ResidenceProof: "ResidenceProof",
    ResponseMessage: "ResponseMessage",
    SearchProvider: "SearchProvider",
    searchterm: "searchterm",
    SearchType: "SearchType",
    SectionName: "SectionName",
    Sex: "Sex",
    SiteVersion: "SiteVersion",
    Slide_Number: "Slide_Number",
    SmartBannerClickType: "SmartBannerClickType",
    SortApplied: "SortApplied",
    SortOrder: "SortOrder",
    Sportsbook_EventPhase: "Sportsbook_EventPhase",
    Sportsbook_EventType: "Sportsbook_EventType",
    StakeForReview: "StakeForReview",
    StartDate: "StartDate",
    StartType: "StartType",
    Status: "Status",
    SubArea: "SubArea",
    TabName: "TabName",
    tags: "tags",
    Target_Url: "Target_Url",
    ToggleField: "ToggleField",
    Topic: "Topic",
    TotalResults: "TotalResults",
    TotalStake: "TotalStake",
    TournamentID: "TournamentID",
    TournamentType: "TournamentType",
    TriggerType: "TriggerType",
    TypeSearchResults: "TypeSearchResults",
    UISelectedAmount: "UISelectedAmount",
    UISelectedCurrency: "UISelectedCurrency",
    ViewType: "ViewType",
    VirtualTitle: "VirtualTitle",
    VirtualUrl: "VirtualUrl",
    WidgetEvent: "WidgetEvent",
    WidgetName: "WidgetName"
};
exports.GtmFilterEnabledVal = {
    True: "true",
    False: "false"
};
exports.GtmLobbyNameVal = {
    Admin: "ADMIN",
    ActivateAccount: "ACTIVATE_ACCOUNT",
    Blog: "BLOG",
    BetGames: "BET_GAMES",
    Bingo: "BINGO",
    Bonuses: "BONUSES",
    Casino: "CASINO",
    Content: "CONTENT",
    CookiePolicy: "COOKIE_POLICY",
    CustomerService: "CUSTOMER_SERVICE",
    Deposit: "DEPOSIT",
    DepositCalculator: "DEPOSIT_CALCULATOR",
    FantasyGames: "FANTASY_GAMES",
    ForgottenPassword: "FORGOTTEN_PASSWORD",
    GameRules: "GAME_RULES",
    Generic: "GENERIC",
    Home: "HOME",
    HorseRacing: "HORSE_RACING",
    Info: "INFO",
    InternalError: "INTERNAL_ERROR",
    Jackpots: "JACKPOTS",
    KycBar: "KYC_BAR",
    LiveCasino: "LIVE_CASINO",
    LiveSportsbook: "LIVE_SPORTSBOOK",
    Login: "LOGIN",
    MarketSelector: "MARKET_SELECTOR",
    MyAccount: "MY_ACCOUNT",
    Oms: "OMS",
    PageNotFound: "PAGE_NOT_FOUND",
    PersonalData: "PERSONAL_DATA",
    Poker: "POKER",
    PrivacyPolicy: "PRIVACY_POLICY",
    Promotions: "PROMOTIONS",
    PromotionsBingo: "PROMOTIONS_BINGO",
    PromotionsCasino: "PROMOTIONS_CASINO",
    PromotionsLiveCasino: "PROMOTIONS_LIVE_CASINO",
    PromotionsLiveSportsbook: "PROMOTIONS_LIVE_SPORTSBOOK",
    PromotionsMixed: "PROMOTIONS_MIXED",
    PromotionsPoker: "PROMOTIONS_POKER",
    PromotionsSportsbook: "PROMOTIONS_SPORTSBOOK",
    Register: "REGISTER",
    ResetPassword: "RESET_PASSWORD",
    ResponsibleGaming: "RESPONSIBLE_GAMING",
    Sportsbook: "SPORTSBOOK",
    SportsbookRules: "SPORTSBOOK_RULES",
    TermsAndConditions: "TERMS_AND_CONDITIONS",
    TwoFA: "TWOFA",
    VerifyPopup: "VERIFY_POPUP",
    VirtualSports: "VIRTUAL_SPORTS",
    WelcomeBonus: "WELCOME_BONUS",
    Withdraw: "WITHDRAW"
};
exports.GtmLoginMethodVal = {
    BankId: "BankID",
    Credentials: "Credentials",
    Facebook: "Facebook",
    FaceID: "FaceID",
    Google: "Google",
    MobileID: "MobileID",
    MitID: "MitID",
    NemId: "NemID",
    OTP: "OTP",
    SmartID: "SmartID",
    Trustly: "Trustly"
};
exports.GtmDepositTypeVal = {
    GameFrame: "GameFrame",
    Normal: "Normal",
    QuickDeposit: "QuickDeposit"
};
exports.GtmInitPlatformVal = {
    Desktop: "desktop",
    Mobile: "mobile",
    Native: "native",
    Tablet: "tablet"
};
exports.GtmPageTypeVal = {
    BannerFlow: "BannerFlow",
    Brand: "Brand",
    Froyo: "Froyo",
    Echo: "Echo",
    Blog: "Blog"
};
exports.GtmRegistrationTypeVal = {
    Cgl: "CGL",
    Dga: "DGA",
    Georgia: "Georgia",
    Iaui: "IAUI",
    Iplyc: "IPLYC",
    Hgc: "HGC",
    Lotba: "LOTBA",
    Mga: "MGA",
    Mta: "Mta",
    Sga: "SGA",
    SmartID: "SmartID",
    Swish: "SWISH",
    Trustly: "Trustly",
    Ukgc: "UKGC",
    MobileID: "MobileID",
    Reda: "Reda",
    Regular: "Regular"
};
exports.GtmLoginStatusVal = {
    LoggedIn: "LoggedIn",
    LoggedOut: "LoggedOut"
};
exports.GtmLoginTypeVal = {
    FirstLogin: "FirstLogin",
    LoggedInExisting: "LoggedInExisting"
};
exports.GDPRGroupsVal = {
    Targeting: "gdpr_targeting_enabled",
    Performance: "gdpr_performance_enabled",
    Functional: "gdpr_functional_enabled"
};
exports.GDPRGroupStateVal = {
    Enabled: "1",
    Disabled: "0"
};
exports.GDPRNewGroupsVal = {
    NewTargeting: "GDPRTargetingAccepted",
    NewPerformance: "GDPRPerformanceAccepted",
    NewFunctional: "GDPRFunctionalAccepted"
};
exports.GDPRNewGroupStatusVal = {
    EnableNow: "1",
    DoNothing: "0"
};
exports.GtmInitBrandVal = {
    AlohaShark: "alohashark",
    ArcticBet: "arcticbet",
    B10: "b10",
    Bets10: "bets10",
    Betsafe: "betsafe",
    BetsafeDE: "betsafede",
    BetsafeEstonia: "betsafeestonia",
    BetsafeLatvia: "betsafelatvia",
    BetsafePE: "betsafepe",
    BetSmith: "betsmith",
    BetSolid: "betsolid",
    Betsson: "betsson",
    BetssonArba: "betssonarba",
    BetssonArbaCity: "betssonarbacity",
    BetssonArcb: "betssonarcb",
    BetssonArgentina: "betssonargentina",
    BetssonBE: "betssonbe",
    BetssonBR: "betssonbr",
    BetssonCO: "betssonco",
    BetssonCZ: "betssoncz",
    BetssonPE: "betssonpe",
    BetssonGR: "betssongr",
    BetssonDE: "betssonde",
    BetssonES: "betssones",
    BetssonMX: "betssonmx",
    BetssonNL: "betssonnl",
    BetssonPY: "betssonpy",
    BetssonUK: "betssonuk",
    CasinoDK: "casinodk",
    CasinoEuro: "casinoeuro",
    CasinoMaxi: "casinomaxi",
    CasinoMetropol: "casinometropol",
    Casinowinner: "casinowinner",
    EuroCasino: "eurocasino",
    EuropeBet: "europebet",
    JackOne: "jackone",
    KroonCasino: "krooncasino",
    MobilBahis: "mobilbahis",
    NordicBet: "nordicbet",
    NordicBetDK: "nordicbetdk",
    NorgesAutomaten: "norgesautomaten",
    OranjeCasino: "oranjecasino",
    StarCasino: "starcasino",
    SverigeAutomaten: "sverigeautomaten",
    SuomiArvat: "suomiarvat"
};
exports.GAEventNameVal = {
    BankIDVerification: "Bank ID Verification",
    Bonus: "Bonus",
    Casino: "Casino",
    Clicks: "Clicks",
    Consent: "Consent",
    CRMPref: "CRM_Preference",
    Default: "Default",
    DocumentVerification: "Document_Verification",
    Error: "Error",
    Experimentation: "Experimentation",
    Feature: "Feature",
    Games: "Games",
    LoginFunnel: "Login_Funnel",
    MatchView: "match_view",
    MyAccount: "My_Account",
    Navigation: "Navigation",
    Notification: "Notification",
    NewRegistration: "new_registration",
    Offers: "Offers",
    Payments: "Payments",
    Promotion: "Promotion",
    PersonalData: "Personal_Data",
    RegistrationFunnel: "Registration_Funnel",
    Search: "Search",
    Sportsbook: "Sportsbook",
    Tournaments: "Tournaments"
};
